<template>
    <C1Button
        type="button"
        variant="secondary"
        :size="size"
        @click.stop.prevent="click()"
        block
    >
        <FontAwesomeIcon
            :icon="btnIcon"
            class="afu-text-neutral--light"
        />
        <div class="af-search-save-btn-text afu-ml-2">
            {{ btnText }}
        </div>
    </C1Button>
</template>

<script>
    import C1Button from '@/components/C1Components/C1Button';

    export default {
        name: 'SearchViewBtn',

        components: {
            C1Button,
        },

        props: {
            view: {
                type: String,
                default: 'list',
                validator: value => ['list', 'map'].includes(value),
            },
            size: {
                type: String,
                default: 'md',
                validator: value => ['sm', 'lg', 'md', 'xl'].includes(value),
            },
        },

        computed: {
            btnText() {
                return this.view === 'map' ? this.$t('search_results.listView') : this.$t('search_results.mapView');
            },

            btnIcon() {
                return this.view === 'map' ? ['far', 'list'] : ['far', 'map-marked'];
            },
        },

        methods: {
            click() {
                this.$emit('click');
            },
        },
    };
</script>
